import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_UNIT = "condominiums-service/units-configs";

class UnitsConfigsService {
	static async listUnitsConfigs() {
		try {
			return await axios.get(BASE_UNIT);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar configurações de unidade",
			});
			return error.response;
		}
	}

	static async getCondominiumUnitsConfigs(condominiumId) {
		try {
			// return await axios.get(BASE_UNIT + "/condominiums/" + condominiumId);
			return { data: {} }
		} catch (error) {
			console.log(error);
			// ResponseAlerts({
			//   response: error.response,
			//   errorMessage: "Erro ao listar configuração de unidade",
			// });
			return error.response;
		}
	}

	static async createUnitsConfigs(payload) {
		try {
			const response = await axios.post(BASE_UNIT, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Configuração de unidade cadastrada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao cadastrar configuração de unidade",
			});
			return error.response;
		}
	}

	static async updateUnitsConfigs(id, payload) {
		return await axios
			.put(BASE_UNIT + "/" + id, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Configuração de unidade atualizada com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar configuração de unidade",
				});
				return error.response;
			});
	}
}

export default UnitsConfigsService;
